/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualLeasingContractDto } from '../../models/backend-actual-leasing-contract-dto';
import { BackendActualLeasingContractRequestDto } from '../../models/backend-actual-leasing-contract-request-dto';

export interface MonitoringActualsLeasingsCreate$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualLeasingContractRequestDto;
}

export function monitoringActualsLeasingsCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsLeasingsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualLeasingContractDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsLeasingsCreate.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualLeasingContractDto>;
    }),
  );
}

monitoringActualsLeasingsCreate.PATH = '/api/monitoring/actuals/leasings/';
